import { log } from "console";
import {
  apiAudioTrack,
  apiCollection,
  apiCollectionFiction,
  apiEpisode,
  apiAuthRoot,
  apiMovie,
  apiPageObject,
  apiSearchResponse,
  apiSerial,
  apiSubtitleTrack,
  PagesEnum,
  apiChart,
} from "./api-models";
import {
  apiAuthLogin,
  apiGetAudio,
  apiGetCharts,
  apiGetCollection,
  apiGetMovie,
  apiGetPage,
  apiGetSeasonEpisodes,
  apiGetSerial,
  apiGetSimilarMovies,
  apiGetSimilarSerials,
  apiGetStudio,
  apiGetSubs,
  apiSearch,
} from "./routes";

var pages: Map<PagesEnum, string> = new Map();
pages.set(PagesEnum.HOME, "30b691e0-48b6-4c9b-bccb-026a7f0b34a7");
pages.set(PagesEnum.SERIALS, "2834b21e-8e42-4b95-9507-e217e44e1e94");
pages.set(PagesEnum.MOVIES, "f1600741-3f3c-43ec-b495-5b9c12754272");
pages.set(PagesEnum.COLLECTIONS, "7e1f54db-c63d-4e12-a43a-b72384b0b20b");
pages.set(PagesEnum.SEARCH, "ee70a261-9954-42a0-b419-4377cca02622");

export async function getPageCollections(
  page: PagesEnum
): Promise<apiPageObject> {
  const homePage = pages.get(page);
  console.log(`Getting page collections for ${page}, pageID: ${homePage}`);

  if (homePage != undefined) {
    try {
      const pageWithCollections = await apiGetPage(homePage);
      console.log(`Page collections result for ${page}:`, pageWithCollections);
      return pageWithCollections;
    } catch (error) {
      console.error(`Error getting page collections for ${page}:`, error);
      return null;
    }
  } else {
    console.error(`No page ID found for ${page}`);
    return null;
  }
}
export async function getCollectionFictions(
  collectionSlug: string
): Promise<{ fictions: apiCollectionFiction[]; collection: apiCollection }> {
  const fictions: apiCollectionFiction[] = [];
  return await apiGetCollection(collectionSlug, 1).then(async (collection) => {
    if (collection.total > 10) {
      collection.collection.collectionFictions.forEach((fiction) => {
        fictions.push(fiction);
      });
      const promises = [];
      for (let i = 2; i <= Math.ceil(collection.total / 10); i++) {
        promises.push(apiGetCollection(collectionSlug, i));
      }
      const collectionRoots = await Promise.all(promises);

      // Обрабатываем полученные данные
      collectionRoots.forEach((root) => {
        root.collection.collectionFictions.forEach((fiction) => {
          fictions.push(fiction);
        });
      });
      return {
        fictions: fictions,
        collection: collection.collection,
      };
    } else {
      return {
        fictions: collection.collection.collectionFictions,
        collection: collection.collection,
      };
    }
  });
}
export async function getMovieInfo(movieId: string): Promise<apiMovie> {
  return apiGetMovie(movieId).then((movie) => {
    return movie;
  });
}
export async function getSerialInfo(serialId: string): Promise<apiSerial> {
  return apiGetSerial(serialId).then((serial) => {
    return serial;
  });
}
export async function getSerialSeasonEpisodes(
  serialId: string,
  seasonNumber: string
): Promise<apiEpisode[]> {
  return apiGetSeasonEpisodes(serialId, seasonNumber).then((episodes) => {
    return episodes.sort((a, b) => a.position - b.position);
  });
}
export async function getPlayerSubsAndAudios(
  imdbid: string
): Promise<{ subs: apiSubtitleTrack[]; audios: apiAudioTrack[] }> {
  const audios = await apiGetAudio(imdbid);
  const subs = await apiGetSubs(imdbid);

  return {
    subs: subs.filter((sub) => sub.visible),
    audios: audios.filter((audio) => audio.visible),
  };
}
export async function getSimilarFictions(
  kind: string,
  imdbid: string
): Promise<(apiMovie | apiSerial)[]> {
  const allFictions =
    kind == "movie"
      ? await apiGetSimilarMovies(imdbid)
      : await apiGetSimilarSerials(imdbid);
  const seen = new Set();
  const fictionsWithoutDuplicates = allFictions.filter((fiction) => {
    const fictionId = fiction.imdbid.replace(/\D/g, "");
    if (seen.has(fictionId)) {
      return false;
    } else {
      seen.add(fictionId);
      return true;
    }
  });

  if (fictionsWithoutDuplicates.length <= 10) {
    return fictionsWithoutDuplicates;
  }

  const shuffled = [...fictionsWithoutDuplicates].sort(
    () => Math.random() - 0.5
  );
  return shuffled.slice(0, 10);
}
export async function getSearchResult(
  querry: string,
  page: number
): Promise<apiSearchResponse> {
  try {
    console.log(`Searching for: "${querry}", page: ${page}`);
    const result = await apiSearch(querry, page.toString());
    console.log(`Search result:`, result);
    return result;
  } catch (error) {
    console.error(`Search error for query "${querry}":`, error);
    // Возвращаем пустой результат вместо ошибки
    return {
      results: [],
      pagination: {
        page: page,
        totalPages: 0,
        totalResults: 0
      }
    };
  }
}
export async function authLogin(
  userName: string,
  password: string
): Promise<apiAuthRoot | boolean> {
  return await apiAuthLogin(userName, password).then((result) => {
    return result;
  });
}
export async function getCharts(): Promise<apiChart[]> {
  console.log("getCharts API call started");
  return await apiGetCharts().then((charts) => {
    console.log("getCharts API response:", charts);
    return charts;
  }).catch((error) => {
    console.error("getCharts API error:", error);
    return null;
  });
}

export async function getStudioContent(studioId: string): Promise<any> {
  console.log(`getStudioContent API call started for studio: ${studioId}`);
  return await apiGetStudio(studioId).then((studio) => {
    console.log(`getStudioContent API response for ${studioId}:`, studio);
    return studio;
  }).catch((error) => {
    console.error(`getStudioContent API error for ${studioId}:`, error);
    return null;
  });
}
